export default __webpack_public_path__ + "static/media/break.29ff56dd.svg";